function localityDecoder(title) {
  if (!title) { return 'Tulum' }

  if (title.match(/Cabo/i)) {
    return 'Cabo San Lucas';
  } else if (title.match(/Cancun/i)) {
    return 'Cancun';
  } else if (title.match(/Oaxaca/i)) {
    return 'Oaxaca de Juarez';
  } else if (title.match(/Ciudad de M|Mexico City/i)) {
    return 'Ciudad de Mexico';
  } else if (title.match(/Playa del Carmen/i)) {
    return 'Playa del Carmen';
  }

  return 'Tulum';
}

export {localityDecoder}
